import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import api from '../services/api';

const Services = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadServices();
  }, []);

  const loadServices = async () => {
    try {
      const response = await api.get('/services/');
      setServices(response.data);
    } catch (error) {
      console.error('Error loading services:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Container className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </Container>
    );
  }

  return (
    <Container className="py-5">
      <h1 className="page-title mb-5">Citizen Services</h1>
      <Row>
        {services.map(service => (
          <Col key={service.id} md={4} className="mb-4">
            <Card className="h-100 service-card">
              <Card.Body>
                {service.icon && (
                  <div className="service-icon text-center mb-3">
                    <i className={`${service.icon} fa-3x text-primary`}></i>
                  </div>
                )}
                <Card.Title className="text-center">
                  <Link to={`/services/${service.slug}`}>{service.name}</Link>
                </Card.Title>
                <Card.Text>
                  {service.description.replace(/<[^>]*>/g, '').substring(0, 150)}...
                </Card.Text>
                <Link to={`/services/${service.slug}`} className="btn btn-primary btn-sm w-100">
                  Learn More
                </Link>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Services;
